import { optimism } from '@wagmi/core/chains';
import type { TokenConfig, TokenSymbol } from './types/tokens';

export const allTokensConfig: Record<number, Record<TokenSymbol, TokenConfig>> = {
	[optimism.id]: {
		USDT: {
			address: '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58',
			showDecimals: 2,
			decimals: '6',
			logo: '/tokens/usdt.svg',
			name: 'USD Tether',
			symbol: 'USDT',
			price: '0'
		},
		LUSD: {
			address: '0xc40f949f8a4e094d1b49a23ea9241d289b7b2819',
			showDecimals: 2,
			decimals: '18',
			logo: '/tokens/lusd.webp',
			name: 'LUSD',
			symbol: 'LUSD',
			price: '0'
		},
		DAI: {
			address: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
			showDecimals: 2,
			decimals: '18',
			logo: '/tokens/dai.webp',
			name: 'DAI',
			symbol: 'DAI',
			price: '0'
		},
		ETH: {
			address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
			showDecimals: 6,
			decimals: '18',
			logo: '/tokens/ethereum.png',
			name: 'Ether',
			symbol: 'ETH',
			price: '0'
		},
		USDCe: {
			address: '0x7F5c764cBc14f9669B88837ca1490cCa17c31607',
			showDecimals: 2,
			decimals: '6',
			logo: '/tokens/usdc.webp',
			name: 'USD Coin',
			symbol: 'USDCe',
			price: '0'
		},
		OP: {
			address: '0x4200000000000000000000000000000000000042',
			showDecimals: 4,
			decimals: '18',
			logo: '/tokens/optimism.svg',
			name: 'Optimism',
			symbol: 'OP',
			price: '0'
		},
		AAVE: {
			address: '0x76fb31fb4af56892a25e32cfc43de717950c9278',
			showDecimals: 4,
			decimals: '18',
			logo: '/tokens/aave.svg',
			name: 'AAVE',
			symbol: 'AAVE',
			price: '0'
		},
		LINK: {
			address: '0x350a791bfc2c21f9ed5d10980dad2e2638ffa7f6',
			showDecimals: 4,
			decimals: '18',
			logo: '/tokens/chainlink.svg',
			name: 'ChainLink',
			symbol: 'LINK',
			price: '0'
		},
		sUSD: {
			address: '0x8c6f28f2F1A3C87F0f938b96d27520d9751ec8d9',
			showDecimals: 2,
			decimals: '18',
			logo: '/tokens/susd.png',
			name: 'sUSD',
			symbol: 'sUSD',
			price: '0'
		},
		sETH: {
			address: '0xE405de8F52ba7559f9df3C368500B6E6ae6Cee49',
			showDecimals: 2,
			decimals: '18',
			logo: '/tokens/susd.png',
			name: 'Ethereum',
			symbol: 'sETH',
			price: '0'
		},
		sBTC: {
			address: '0x298B9B95708152ff6968aafd889c6586e9169f1D',
			showDecimals: 8,
			decimals: '18',
			logo: '/tokens/btc.svg',
			name: 'Bitcoin',
			symbol: 'sBTC',
			price: '0'
		},
		sLINK: {
			address: '0xc5Db22719A06418028A40A9B5E9A7c02959D0d08',
			showDecimals: 4,
			decimals: '18',
			logo: '/tokens/chainlink.svg',
			name: 'ChainLink',
			symbol: 'sLINK',
			price: '0'
		},
		sSOL: {
			address: '0x8b2F7Ae8cA8EE8428B6D76dE88326bB413db2766',
			showDecimals: 4,
			decimals: '18',
			logo: '/tokens/solana.svg',
			name: 'Solana',
			symbol: 'sSOL',
			price: '0'
		},
		sAVAX: {
			address: '0xB2b42B231C68cbb0b4bF2FFEbf57782Fd97D3dA4',
			showDecimals: 4,
			decimals: '18',
			logo: '/tokens/avax.svg',
			name: 'AVAX',
			symbol: 'sAVAX',
			price: '0'
		},
		sMATIC: {
			address: '0x81DDfAc111913d3d5218DEA999216323B7CD6356',
			showDecimals: 4,
			decimals: '18',
			logo: '/tokens/matic.svg',
			name: 'Matic',
			symbol: 'sMATIC',
			price: '0'
		},
		sAAVE: {
			address: '0x00B8D5a5e1Ac97Cb4341c4Bc4367443c8776e8d9',
			showDecimals: 4,
			decimals: '18',
			logo: '/tokens/aave.svg',
			name: 'AAVE',
			symbol: 'sAAVE',
			price: '0'
		},
		sEUR: {
			address: '0xFBc4198702E81aE77c06D58f81b629BDf36f0a71',
			showDecimals: 2,
			decimals: '18',
			logo: '/tokens/susd.png', //No image
			name: 'EUR',
			symbol: 'sEUR',
			price: '0'
		},
		sUNI: {
			address: '0xf5a6115Aa582Fd1BEEa22BC93B7dC7a785F60d03',
			showDecimals: 5,
			decimals: '18',
			logo: '/tokens/susd.png', //No image
			name: 'UNI',
			symbol: 'sUNI',
			price: '0'
		},
		sINR: {
			address: '0x34c2360ffe5D21542f76e991FFD104f281D4B3fb',
			showDecimals: 2,
			decimals: '18',
			logo: '/tokens/susd.png', //No image
			name: 'INR',
			symbol: 'sINR',
			price: '0'
		}
	}
};

export const optimismTokensConfig: Record<string, TokenConfig> = allTokensConfig[optimism.id];

export const getTokenForAddress = (
	address: string,
	id: number = optimism.id
): TokenConfig | undefined => {
	return Object.values(allTokensConfig[id]).find((token) => token.address === address);
};

export const getTokenLogo = (symbol: TokenSymbol, id: number = optimism.id): string => {
	return allTokensConfig[id][symbol]['logo'];
};
